export enum ENativeRemainingTimeEvent {
  Update     = 'RemainingTime:Update',
  Reactivate = 'RemainingTime:Reactivate'
}

export { ENativeNavigateEvent } from '@apps/definitions'
